declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../models/api_request_model';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { DOCService } from '../../../../services/doc.service';
import { DownloadFileRequest } from '../../../../models/docs/doc.model';
import { ActorIdentitiesRequest, ActorDocRequest, ActorDocController, SaveCounsellingPlanRequest, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest } from '../../../../models/actor/actor';
import { ActorService } from '../../../../services/actor.service';
import { DBOperation } from '../../../../enums/enum';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';

@Component({
  selector: 'searchdonarre',
  templateUrl: './searchdonarre.modal.html',
  styleUrls: ['./searchdonarre.modal.scss']
})

export class NgbSearchDonarreModal implements OnInit {


  @Input() ActorDocCode;
  @Input() DownloadActorImageFileExtension: string;
  @Input() DownloadActorImageFile: string;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  @Input() CanEdit: number;
  @Input() CanShow: number;

  DOB: NgbDateStruct;
  maxDate: NgbDateStruct;
  minDate: NgbDateStruct;

  StartDate: NgbDateStruct;
  RecommendedPackage: string;
  Doctor: string;
  PackageCost: number;
  SelectEmi: boolean;
  Concerns: string;
  AddRemarks: string;
  file: File;
  fileList: FileList;
  public Name: string;
  public FormattedCode: string;
  public ActorCode: number;


  FileExtension: string = "";
  MaritalStatus: string;
  JobType: string;
  public isRequesting: boolean = false;
  public ApiResData: ApiResponseModel;
  public ApiReqData: ApiRequestModel
  private modalRef: NgbModalRef;
  DocFriendlyName: string = "";
  
  CurrentPatientInfoByFormattedCodeController: PatientInfoByFormattedCodeController[];
  CurrentPatientInfoByFormattedCodeRequest: PatientInfoByFormattedCodeRequest;
  LoadPatients() {
    this.CurrentPatientInfoByFormattedCodeRequest = new PatientInfoByFormattedCodeRequest();
    this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = "";
    this.CurrentPatientInfoByFormattedCodeRequest.Branch = 0;
    this.CurrentPatientInfoByFormattedCodeRequest.ConditionalOperator = 30;
    this.CurrentPatientInfoByFormattedCodeRequest.FromDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.ToDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.IsToday = true;
    this.CurrentPatientInfoByFormattedCodeRequest.IsDuration = false;
    this.CurrentPatientInfoByFormattedCodeRequest.SearchText = "";

    this.CurrentPatientInfoByFormattedCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetPatientInfoByFormattedCodeController();
  }
  RefreshPatients(st: string) {
    this.CurrentPatientInfoByFormattedCodeRequest = new PatientInfoByFormattedCodeRequest();
    this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = "";
    this.CurrentPatientInfoByFormattedCodeRequest.Branch = 0;
    this.CurrentPatientInfoByFormattedCodeRequest.ConditionalOperator = 20;
    this.CurrentPatientInfoByFormattedCodeRequest.FromDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.ToDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.IsToday = true;
    this.CurrentPatientInfoByFormattedCodeRequest.IsDuration = false;
    this.CurrentPatientInfoByFormattedCodeRequest.SearchText = st;

    this.CurrentPatientInfoByFormattedCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this._GetPatientInfoByFormattedCodeController();
  }
  _GetPatientInfoByFormattedCodeController() {
    this.StartRefreshing();


    this.actorservice.GetPatientInfoByFormattedCodeController(this.CurrentPatientInfoByFormattedCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentPatientInfoByFormattedCodeController = null;
          this.CurrentPatientInfoByFormattedCodeController = this.ApiResData.Result;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  GetPatientInfoByFormattedCodeController() {
    this.StartRefreshing();


    this.actorservice.GetPatientInfoByFormattedCodeController(this.CurrentPatientInfoByFormattedCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentPatientInfoByFormattedCodeController = this.ApiResData.Result;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  

  

  @ViewChild('f') IdentitiesDocForm: NgForm;
  public UploadActorDoc: any;

  public CanDownLoadActorDoc: number

  public CanNurseView: number =0 ;



  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService, private docservice: DOCService,
    private router: Router, private route: ActivatedRoute, private actorservice: ActorService, private tosterservice: NGXToastrService, private parserFormatter: NgbDateParserFormatter) { }
  ngOnInit() {

    this.LoadPatients();

    

    

  }

  criteriaChange(value: string) {
    this.RefreshPatients(value);
    // if (this.filter != null) {
    //if (value != '[object Event]') {
    //  this.listFilter = value;
    //  //alert(this.listFilter);
    //  this.pdata = this.filter.transform(this.CurrentResourceIdentificationByDateInfoController,
    //    this.listFilter);
    //}

  }
  passback(l: PatientInfoByFormattedCodeController) {
    this.Name = l.DisplayName;
    this.FormattedCode = l.FormattedCode;
    this.ActorCode = l.ActorCode;
    this.passEntry.emit({ make: this.Name, value: this.FormattedCode, key2: this.ActorCode });
    //this.passEntry.emit(this.User2);
    this.activeModal.dismiss('Cross click');
  }
  SelectedPatientDetails: PatientInfoByFormattedCodeController;

  SelectedPatient(objCategory: any) {
    var patient: PatientInfoByFormattedCodeController = objCategory;
    if (patient != null) {

      //this.router.navigate(['testnurse/serviceconfig']);
      this.SelectedPatientDetails = patient;

      this.activeModal.dismiss;
      //alert(document[0].ActorDocPageCode);
      //let options: NgbModalOptions = {
      //  size: 'lg',
      //  centered: true
      //};
      //const modalRef = this.modalService.open(NgbDocumentModal, options)
      //modalRef.componentInstance.DocFriendlyName = document.DocFriendlyName;
      //modalRef.componentInstance.DocTitle = document.DocTitle;
      //modalRef.componentInstance.DocCaptureDate = document.DocCaptureDate;
      //modalRef.componentInstance.ActorDocPageCode = document.ActorDocPageCode;

    }
    else {

    }
  }
 
 
  
private stopRefreshing() {
  this.loaderService.displayLoader(false);
  this.isRequesting = false;
}
  private StartRefreshing() {
  this.loaderService.displayLoader(true);
  this.isRequesting = true;
  }
  editfollicular() {
    this.router.navigate(['nurse/editfollicular']);
    this.activeModal.close();
  }
}





  //GetActorDocController() {
  //  this.StartRefreshing();
  //  this.docservice.GetActorDocController(this.CurrentActorDocRequest)
  //    .subscribe((result) => {
  //      this.ApiResData = result;
  //      if (!this.ApiResData.hasError) {

  //        this.CurrentActorDocController = this.ApiResData.Result;
  //        this.initGridButton();
  //        this.stopRefreshing();

  //      }
  //      else {
  //        this.stopRefreshing();
  //        if (this.ApiResData.ErrorData != "") {

  //          alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
  //        }
  //        else {
  //          alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
  //        }
  //      }

  //    },


  //    (error) => {

  //      if (error == "401 - Unauthorized") {
  //        alertFunctions.AlertParamEr(error);
  //        this.stopRefreshing();



  //      }
  //      else {
  //        alertFunctions.AlertParamEr(error);
  //        this.stopRefreshing();
  //      }
  //    }


  //    );

  //}

  

  /////////////////////////



  //

  // https://www.codeproject.com/Articles/1195569/Angular-Data-Grid-with-Sorting-Filtering-Export-to
  // dbops: DBOperation;
  //Grid Vars start














  /////////////////////////

